import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

/**
 * Single read that backs the "delete user" modal: lists the content owned by a
 * user (collections, klydos, Shopify artist meta-object) in one call so the
 * admin can review it before choosing what to also delete. Only runs while
 * `enabled` is true (i.e. the modal is open).
 */
export const useUserContent = (userId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ["userContent", userId],
    queryFn: () => adminApiClient.getUserContent(userId),
    enabled: enabled && !!userId,
  });
};
